import { countSetFilters } from '@/util/filter-count';
import { getZonesCount } from '@/util/zones-util';

const zonesCount = (zones) => {
  if (!zones || typeof zones !== 'object') return 0;
  try {
    return getZonesCount(zones);
  } catch (e) {
    return 0;
  }
};

// The advanced filters set (keywords, where they're looked for, categories, zones): the badge of
// Explore's advanced filters.
export const advancedFiltersCount = (filters) =>
  (filters.matchContexts || []).length +
  (filters.keywordIds || []).length +
  (filters.procurementCategories || []).length +
  zonesCount(filters.zones);

// SEAO's own settings, reached from the platforms filter.
export const hasSeaoFilters = (filters) => {
  const regions = (filters.administrativeRegions || {}).seao_v2 || [];
  const seao = (filters.classifications || []).find((classification) => classification.scheme === 'SEAO');
  return regions.length > 0 || !!(seao && seao.codes && seao.codes.length);
};

// How many of Explore's filters are set, as the phone's "Filtres (N)" counts them: the platforms
// with their SEAO settings as one, the advanced filters as one. Not the search.
export const exploreFilterCount = (filters) =>
  countSetFilters([
    (filters.platforms || []).length || hasSeaoFilters(filters) ? true : null,
    filters.statuses,
    filters.closingBefore,
    filters.publishedAfter || filters.publishedBefore,
    filters.readFilters,
    filters.followFilters,
    filters.shareFilters,
    filters.assigneesFilters,
    advancedFiltersCount(filters) ? true : null,
  ]);
